"use client";

import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.string.split.js";
var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, _typeof(key) !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.tsx
import { cloneElement, isValidElement, useCallback, useEffect as useEffect2, useReducer, useRef as useRef2, useState } from "react";
import convert2 from "react-from-dom";

// src/config.ts
var CACHE_NAME = "react-inlinesvg";
var CACHE_MAX_RETRIES = 10;
var STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};

// src/modules/helpers.ts
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function isSupportedEnvironment() {
  return supportsInlineSVG() && typeof window !== "undefined" && window !== null;
}
function request(_x, _x2) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(url, options) {
    var response, contentType, _split, _split2, fileType;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return fetch(url, options);
        case 2:
          response = _context12.sent;
          contentType = response.headers.get("content-type");
          _split = (contentType !== null && contentType !== void 0 ? contentType : "").split(/ ?; ?/), _split2 = _slicedToArray(_split, 1), fileType = _split2[0];
          if (!(response.status > 299)) {
            _context12.next = 7;
            break;
          }
          throw new Error("Not found");
        case 7:
          if (["image/svg+xml", "text/plain"].some(function (d) {
            return fileType.includes(d);
          })) {
            _context12.next = 9;
            break;
          }
          throw new Error("Content type isn't valid: ".concat(fileType));
        case 9:
          return _context12.abrupt("return", response.text());
        case 10:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _request.apply(this, arguments);
}
function sleep() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise(function (resolve) {
    setTimeout(resolve, seconds * 1e3);
  });
}
function supportsInlineSVG() {
  if (!document) {
    return false;
  }
  var div = document.createElement("div");
  div.innerHTML = "<svg />";
  var svg = div.firstChild;
  return !!svg && svg.namespaceURI === "http://www.w3.org/2000/svg";
}
function randomCharacter(character) {
  return character[Math.floor(Math.random() * character.length)];
}
function randomString(length) {
  var letters = "abcdefghijklmnopqrstuvwxyz";
  var numbers = "1234567890";
  var charset = "".concat(letters).concat(letters.toUpperCase()).concat(numbers);
  var R = "";
  for (var index = 0; index < length; index++) {
    R += randomCharacter(charset);
  }
  return R;
}
function omit(input) {
  var output = {};
  for (var _len = arguments.length, filter = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filter[_key - 1] = arguments[_key];
  }
  for (var key in input) {
    if ({}.hasOwnProperty.call(input, key)) {
      if (!filter.includes(key)) {
        output[key] = input[key];
      }
    }
  }
  return output;
}

// src/modules/cache.ts
var CacheStore = /*#__PURE__*/function () {
  function CacheStore() {
    var _this = this;
    _classCallCheck(this, CacheStore);
    __publicField(this, "cacheApi");
    __publicField(this, "cacheStore");
    __publicField(this, "subscribers", []);
    __publicField(this, "isReady", false);
    this.cacheStore = /* @__PURE__ */new Map();
    var cacheName = CACHE_NAME;
    var usePersistentCache = false;
    if (canUseDOM()) {
      var _window$REACT_INLINES;
      cacheName = (_window$REACT_INLINES = window.REACT_INLINESVG_CACHE_NAME) !== null && _window$REACT_INLINES !== void 0 ? _window$REACT_INLINES : CACHE_NAME;
      usePersistentCache = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window;
    }
    if (usePersistentCache) {
      caches.open(cacheName).then(function (cache) {
        _this.cacheApi = cache;
        _this.isReady = true;
        _this.subscribers.forEach(function (callback) {
          return callback();
        });
      }).catch(function (error) {
        _this.isReady = true;
        console.error("Failed to open cache: ".concat(error.message));
      });
    } else {
      this.isReady = true;
    }
  }
  _createClass(CacheStore, [{
    key: "onReady",
    value: function onReady(callback) {
      if (this.isReady) {
        callback();
      } else {
        this.subscribers.push(callback);
      }
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, fetchOptions) {
        var _this$cacheStore$get$, _this$cacheStore$get;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.cacheApi ? this.fetchAndAddToPersistentCache(url, fetchOptions) : this.fetchAndAddToInternalCache(url, fetchOptions);
            case 2:
              return _context.abrupt("return", (_this$cacheStore$get$ = (_this$cacheStore$get = this.cacheStore.get(url)) === null || _this$cacheStore$get === void 0 ? void 0 : _this$cacheStore$get.content) !== null && _this$cacheStore$get$ !== void 0 ? _this$cacheStore$get$ : "");
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x3, _x4) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "set",
    value: function set(url, data) {
      this.cacheStore.set(url, data);
    }
  }, {
    key: "isCached",
    value: function isCached(url) {
      var _this$cacheStore$get2;
      return ((_this$cacheStore$get2 = this.cacheStore.get(url)) === null || _this$cacheStore$get2 === void 0 ? void 0 : _this$cacheStore$get2.status) === STATUS.LOADED;
    }
  }, {
    key: "fetchAndAddToInternalCache",
    value: function () {
      var _fetchAndAddToInternalCache = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, fetchOptions) {
        var _this2 = this;
        var cache, content;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              cache = this.cacheStore.get(url);
              if (!((cache === null || cache === void 0 ? void 0 : cache.status) === STATUS.LOADING)) {
                _context3.next = 5;
                break;
              }
              _context3.next = 4;
              return this.handleLoading(url, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _this2.cacheStore.set(url, {
                        content: "",
                        status: STATUS.IDLE
                      });
                      _context2.next = 3;
                      return _this2.fetchAndAddToInternalCache(url, fetchOptions);
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })));
            case 4:
              return _context3.abrupt("return");
            case 5:
              if (cache !== null && cache !== void 0 && cache.content) {
                _context3.next = 18;
                break;
              }
              this.cacheStore.set(url, {
                content: "",
                status: STATUS.LOADING
              });
              _context3.prev = 7;
              _context3.next = 10;
              return request(url, fetchOptions);
            case 10:
              content = _context3.sent;
              this.cacheStore.set(url, {
                content: content,
                status: STATUS.LOADED
              });
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](7);
              this.cacheStore.set(url, {
                content: "",
                status: STATUS.FAILED
              });
              throw _context3.t0;
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[7, 14]]);
      }));
      function fetchAndAddToInternalCache(_x5, _x6) {
        return _fetchAndAddToInternalCache.apply(this, arguments);
      }
      return fetchAndAddToInternalCache;
    }()
  }, {
    key: "fetchAndAddToPersistentCache",
    value: function () {
      var _fetchAndAddToPersistentCache = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url, fetchOptions) {
        var _this3 = this,
          _this$cacheApi;
        var cache, data, content, _this$cacheApi2, _this$cacheApi3, _yield$response$text, response, _content;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              cache = this.cacheStore.get(url);
              if (!((cache === null || cache === void 0 ? void 0 : cache.status) === STATUS.LOADED)) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              if (!((cache === null || cache === void 0 ? void 0 : cache.status) === STATUS.LOADING)) {
                _context5.next = 7;
                break;
              }
              _context5.next = 6;
              return this.handleLoading(url, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _this3.cacheStore.set(url, {
                        content: "",
                        status: STATUS.IDLE
                      });
                      _context4.next = 3;
                      return _this3.fetchAndAddToPersistentCache(url, fetchOptions);
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              })));
            case 6:
              return _context5.abrupt("return");
            case 7:
              this.cacheStore.set(url, {
                content: "",
                status: STATUS.LOADING
              });
              _context5.next = 10;
              return (_this$cacheApi = this.cacheApi) === null || _this$cacheApi === void 0 ? void 0 : _this$cacheApi.match(url);
            case 10:
              data = _context5.sent;
              if (!data) {
                _context5.next = 17;
                break;
              }
              _context5.next = 14;
              return data.text();
            case 14:
              content = _context5.sent;
              this.cacheStore.set(url, {
                content: content,
                status: STATUS.LOADED
              });
              return _context5.abrupt("return");
            case 17:
              _context5.prev = 17;
              _context5.next = 20;
              return (_this$cacheApi2 = this.cacheApi) === null || _this$cacheApi2 === void 0 ? void 0 : _this$cacheApi2.add(new Request(url, fetchOptions));
            case 20:
              _context5.next = 22;
              return (_this$cacheApi3 = this.cacheApi) === null || _this$cacheApi3 === void 0 ? void 0 : _this$cacheApi3.match(url);
            case 22:
              response = _context5.sent;
              _context5.next = 25;
              return response === null || response === void 0 ? void 0 : response.text();
            case 25:
              _context5.t1 = _yield$response$text = _context5.sent;
              _context5.t0 = _context5.t1 !== null;
              if (!_context5.t0) {
                _context5.next = 29;
                break;
              }
              _context5.t0 = _yield$response$text !== void 0;
            case 29:
              if (!_context5.t0) {
                _context5.next = 33;
                break;
              }
              _context5.t2 = _yield$response$text;
              _context5.next = 34;
              break;
            case 33:
              _context5.t2 = "";
            case 34:
              _content = _context5.t2;
              this.cacheStore.set(url, {
                content: _content,
                status: STATUS.LOADED
              });
              _context5.next = 42;
              break;
            case 38:
              _context5.prev = 38;
              _context5.t3 = _context5["catch"](17);
              this.cacheStore.set(url, {
                content: "",
                status: STATUS.FAILED
              });
              throw _context5.t3;
            case 42:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[17, 38]]);
      }));
      function fetchAndAddToPersistentCache(_x7, _x8) {
        return _fetchAndAddToPersistentCache.apply(this, arguments);
      }
      return fetchAndAddToPersistentCache;
    }()
  }, {
    key: "handleLoading",
    value: function () {
      var _handleLoading = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url, callback) {
        var retryCount, _this$cacheStore$get3;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              retryCount = 0;
            case 1:
              if (!(((_this$cacheStore$get3 = this.cacheStore.get(url)) === null || _this$cacheStore$get3 === void 0 ? void 0 : _this$cacheStore$get3.status) === STATUS.LOADING && retryCount < CACHE_MAX_RETRIES)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 4;
              return sleep(0.1);
            case 4:
              retryCount += 1;
              _context6.next = 1;
              break;
            case 7:
              if (!(retryCount >= CACHE_MAX_RETRIES)) {
                _context6.next = 10;
                break;
              }
              _context6.next = 10;
              return callback();
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleLoading(_x9, _x10) {
        return _handleLoading.apply(this, arguments);
      }
      return handleLoading;
    }()
  }, {
    key: "keys",
    value: function keys() {
      return _toConsumableArray(this.cacheStore.keys());
    }
  }, {
    key: "data",
    value: function data() {
      return _toConsumableArray(this.cacheStore.entries()).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return _defineProperty({}, key, value);
      });
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(url) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.cacheApi) {
                _context7.next = 3;
                break;
              }
              _context7.next = 3;
              return this.cacheApi.delete(url);
            case 3:
              this.cacheStore.delete(url);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function _delete(_x11) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var keys, _iterator, _step, key;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.cacheApi) {
                _context8.next = 21;
                break;
              }
              _context8.next = 3;
              return this.cacheApi.keys();
            case 3:
              keys = _context8.sent;
              _iterator = _createForOfIteratorHelper(keys);
              _context8.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context8.next = 13;
                break;
              }
              key = _step.value;
              _context8.next = 11;
              return this.cacheApi.delete(key);
            case 11:
              _context8.next = 7;
              break;
            case 13:
              _context8.next = 18;
              break;
            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](5);
              _iterator.e(_context8.t0);
            case 18:
              _context8.prev = 18;
              _iterator.f();
              return _context8.finish(18);
            case 21:
              this.cacheStore.clear();
            case 22:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[5, 15, 18, 21]]);
      }));
      function clear() {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
  }]);
  return CacheStore;
}();

// src/modules/hooks.tsx
import { useEffect, useRef } from "react";
function usePrevious(state) {
  var ref = useRef();
  useEffect(function () {
    ref.current = state;
  });
  return ref.current;
}

// src/modules/utils.ts
import convert from "react-from-dom";
function getNode(options) {
  var baseURL = options.baseURL,
    content = options.content,
    description = options.description,
    handleError = options.handleError,
    hash = options.hash,
    preProcessor = options.preProcessor,
    title = options.title,
    _options$uniquifyIDs = options.uniquifyIDs,
    uniquifyIDs = _options$uniquifyIDs === void 0 ? false : _options$uniquifyIDs;
  try {
    var svgText = processSVG(content, preProcessor);
    var node = convert(svgText, {
      nodeOnly: true
    });
    if (!node || !(node instanceof SVGSVGElement)) {
      throw new Error("Could not convert the src to a DOM Node");
    }
    var svg = updateSVGAttributes(node, {
      baseURL: baseURL,
      hash: hash,
      uniquifyIDs: uniquifyIDs
    });
    if (description) {
      var originalDesc = svg.querySelector("desc");
      if (originalDesc !== null && originalDesc !== void 0 && originalDesc.parentNode) {
        originalDesc.parentNode.removeChild(originalDesc);
      }
      var descElement = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      descElement.innerHTML = description;
      svg.prepend(descElement);
    }
    if (typeof title !== "undefined") {
      var originalTitle = svg.querySelector("title");
      if (originalTitle !== null && originalTitle !== void 0 && originalTitle.parentNode) {
        originalTitle.parentNode.removeChild(originalTitle);
      }
      if (title) {
        var titleElement = document.createElementNS("http://www.w3.org/2000/svg", "title");
        titleElement.innerHTML = title;
        svg.prepend(titleElement);
      }
    }
    return svg;
  } catch (error) {
    return handleError(error);
  }
}
function processSVG(content, preProcessor) {
  if (preProcessor) {
    return preProcessor(content);
  }
  return content;
}
function updateSVGAttributes(node, options) {
  var _options$baseURL = options.baseURL,
    baseURL = _options$baseURL === void 0 ? "" : _options$baseURL,
    hash = options.hash,
    uniquifyIDs = options.uniquifyIDs;
  var replaceableAttributes = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"];
  var linkAttributes = ["href", "xlink:href"];
  var isDataValue = function isDataValue(name, value) {
    return linkAttributes.includes(name) && (value ? !value.includes("#") : false);
  };
  if (!uniquifyIDs) {
    return node;
  }
  _toConsumableArray(node.children).forEach(function (d) {
    var _d$attributes;
    if ((_d$attributes = d.attributes) !== null && _d$attributes !== void 0 && _d$attributes.length) {
      var attributes = Object.values(d.attributes).map(function (a) {
        var attribute = a;
        var match = /url\((.*?)\)/.exec(a.value);
        if (match !== null && match !== void 0 && match[1]) {
          attribute.value = a.value.replace(match[0], "url(".concat(baseURL).concat(match[1], "__").concat(hash, ")"));
        }
        return attribute;
      });
      replaceableAttributes.forEach(function (r) {
        var attribute = attributes.find(function (a) {
          return a.name === r;
        });
        if (attribute && !isDataValue(r, attribute.value)) {
          attribute.value = "".concat(attribute.value, "__").concat(hash);
        }
      });
    }
    if (d.children.length) {
      return updateSVGAttributes(d, options);
    }
    return d;
  });
  return node;
}

// src/index.tsx
import { jsx } from "react/jsx-runtime";
var cacheStore;
function ReactInlineSVG(props) {
  var _props$cacheRequests = props.cacheRequests,
    cacheRequests = _props$cacheRequests === void 0 ? true : _props$cacheRequests,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    description = props.description,
    fetchOptions = props.fetchOptions,
    innerRef = props.innerRef,
    _props$loader = props.loader,
    loader = _props$loader === void 0 ? null : _props$loader,
    onError = props.onError,
    onLoad = props.onLoad,
    src = props.src,
    title = props.title,
    uniqueHash = props.uniqueHash;
  var _useReducer = useReducer(function (previousState2, nextState) {
      return _objectSpread(_objectSpread({}, previousState2), nextState);
    }, {
      content: "",
      element: null,
      isCached: cacheRequests && cacheStore.isCached(props.src),
      status: STATUS.IDLE
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    setState = _useReducer2[1];
  var content = state.content,
    element = state.element,
    isCached = state.isCached,
    status = state.status;
  var previousProps = usePrevious(props);
  var previousState = usePrevious(state);
  var hash = useRef2(uniqueHash !== null && uniqueHash !== void 0 ? uniqueHash : randomString(8));
  var isActive = useRef2(false);
  var isInitialized = useRef2(false);
  var handleError = useCallback(function (error) {
    if (isActive.current) {
      setState({
        status: error.message === "Browser does not support SVG" ? STATUS.UNSUPPORTED : STATUS.FAILED
      });
      onError === null || onError === void 0 ? void 0 : onError(error);
    }
  }, [onError]);
  var handleLoad = useCallback(function (loadedContent) {
    var hasCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isActive.current) {
      setState({
        content: loadedContent,
        isCached: hasCache,
        status: STATUS.LOADED
      });
    }
  }, []);
  var fetchContent = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    var responseContent;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request(src, fetchOptions);
        case 2:
          responseContent = _context9.sent;
          handleLoad(responseContent);
        case 4:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  })), [fetchOptions, handleLoad, src]);
  var getElement = useCallback(function () {
    try {
      var node = getNode(_objectSpread(_objectSpread({}, props), {}, {
        handleError: handleError,
        hash: hash.current,
        content: content
      }));
      var convertedElement = convert2(node);
      if (!convertedElement || ! /*#__PURE__*/isValidElement(convertedElement)) {
        throw new Error("Could not convert the src to a React element");
      }
      setState({
        element: convertedElement,
        status: STATUS.READY
      });
    } catch (error) {
      handleError(new Error(error.message));
    }
  }, [content, handleError, props]);
  var getContent = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    var dataURI, inlineSrc, cachedContent;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          dataURI = /^data:image\/svg(?:(?!,)[\s\S])*?(;base64)?,((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)/.exec(src);
          if (dataURI) {
            inlineSrc = dataURI[1] ? window.atob(dataURI[2]) : decodeURIComponent(dataURI[2]);
          } else if (src.includes("<svg")) {
            inlineSrc = src;
          }
          if (!inlineSrc) {
            _context10.next = 5;
            break;
          }
          handleLoad(inlineSrc);
          return _context10.abrupt("return");
        case 5:
          _context10.prev = 5;
          if (!cacheRequests) {
            _context10.next = 13;
            break;
          }
          _context10.next = 9;
          return cacheStore.get(src, fetchOptions);
        case 9:
          cachedContent = _context10.sent;
          handleLoad(cachedContent, true);
          _context10.next = 15;
          break;
        case 13:
          _context10.next = 15;
          return fetchContent();
        case 15:
          _context10.next = 20;
          break;
        case 17:
          _context10.prev = 17;
          _context10.t0 = _context10["catch"](5);
          handleError(_context10.t0);
        case 20:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[5, 17]]);
  })), [cacheRequests, fetchContent, fetchOptions, handleError, handleLoad, src]);
  var load = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          if (isActive.current) {
            setState({
              content: "",
              element: null,
              isCached: false,
              status: STATUS.LOADING
            });
          }
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  })), []);
  useEffect2(function () {
    isActive.current = true;
    if (!canUseDOM() || isInitialized.current) {
      return function () {
        return void 0;
      };
    }
    try {
      if (status === STATUS.IDLE) {
        if (!isSupportedEnvironment()) {
          throw new Error("Browser does not support SVG");
        }
        if (!src) {
          throw new Error("Missing src");
        }
        load();
      }
    } catch (error) {
      handleError(error);
    }
    isInitialized.current = true;
    return function () {
      isActive.current = false;
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect2(function () {
    if (!canUseDOM()) {
      return;
    }
    if (!previousProps) {
      return;
    }
    if (previousProps.src !== src) {
      if (!src) {
        handleError(new Error("Missing src"));
        return;
      }
      load();
    } else if (previousProps.title !== title || previousProps.description !== description) {
      getElement();
    }
  }, [description, getElement, handleError, load, previousProps, src, title]);
  useEffect2(function () {
    if (!previousState) {
      return;
    }
    if (previousState.status !== STATUS.LOADING && status === STATUS.LOADING) {
      getContent();
    }
    if (previousState.status !== STATUS.LOADED && status === STATUS.LOADED) {
      getElement();
    }
    if (previousState.status !== STATUS.READY && status === STATUS.READY) {
      onLoad === null || onLoad === void 0 ? void 0 : onLoad(src, isCached);
    }
  }, [getContent, getElement, isCached, onLoad, previousState, src, status]);
  var elementProps = omit(props, "baseURL", "cacheRequests", "children", "description", "fetchOptions", "innerRef", "loader", "onError", "onLoad", "preProcessor", "src", "title", "uniqueHash", "uniquifyIDs");
  if (!canUseDOM()) {
    return loader;
  }
  if (element) {
    return /*#__PURE__*/cloneElement(element, _objectSpread({
      ref: innerRef
    }, elementProps));
  }
  if ([STATUS.UNSUPPORTED, STATUS.FAILED].includes(status)) {
    return children;
  }
  return loader;
}
function InlineSVG(props) {
  if (!cacheStore) {
    cacheStore = new CacheStore();
  }
  var loader = props.loader;
  var hasCallback = useRef2(false);
  var _useState = useState(cacheStore.isReady),
    _useState2 = _slicedToArray(_useState, 2),
    isReady = _useState2[0],
    setReady = _useState2[1];
  useEffect2(function () {
    if (!hasCallback.current) {
      cacheStore.onReady(function () {
        setReady(true);
      });
      hasCallback.current = true;
    }
  }, []);
  if (!isReady) {
    return loader;
  }
  return /* @__PURE__ */jsx(ReactInlineSVG, _objectSpread({}, props));
}
export { cacheStore, InlineSVG as default };